import appConfig from "@/app.config";
// import { getActivePinia } from 'pinia';
// import { useAuthStore } from '@/state/pinia';
import { canPersonTypeOperation, canCategoryPersonTypeOperation, canPermissions } from "@/helpers/middleware_func";

export const directives = [
    // {
    //     name: 'can',
    //     func: (el, binding) => {
    //         const pinia = getActivePinia();
    //         const authStore = useAuthStore(pinia);
    //         const user = authStore.getUser;

    //         let permissions = Array.isArray(binding.value) ? binding.value : binding.value.split('|')
    //         if (!user.hasAnyPermission(permissions))
    //             binding.arg === 'disable'? el.disabled = true : hideElement(el) 
    //     }
    // },
    // {
    //     name: 'canAny',
    //     func: (el, binding) => {
    //         const pinia = getActivePinia();
    //         const authStore = useAuthStore(pinia);
    //         const user = authStore.getUser;

    //         let permissions = Array.isArray(binding.value) ? binding.value : binding.value.split('|')
    //        console.log('canAny directive called with permissions:', permissions);
    //         if (!user.hasAnyPermission(permissions))
    //             binding.arg === 'disable'? el.disabled = true : hideElement(el) 
    //     }
    // },
    // {
    //     name: 'canAll',
    //     func: (el, binding) => {
    //         const pinia = getActivePinia();
    //         const authStore = useAuthStore(pinia);
    //         const user = authStore.getUser;

    //         let permissions = Array.isArray(binding.value) ? binding.value : binding.value.split(',')
    //         if (!user.hasAllPermissions(permissions))
    //             binding.arg === 'disable'? el.disabled = true : hideElement(el) 
    //     }
    // },
    {
        name: 'can',
        func: (el, binding) => {
            if (!canPermissions(binding.value)) {
                binding.arg === 'disable'? el.disabled = true : hideElement(el);
            }
        }
    },
    {
        name: 'canPersonTypeOperation',
        func: (el, binding) => {
           if (!canPersonTypeOperation(binding.value)) {
                binding.arg === 'disable'? el.disabled = true : hideElement(el);
            }
        }
    },
    {
        name: 'canCategoryPersonTypeOperation',
        func: (el, binding) => {
            if (!canCategoryPersonTypeOperation(binding.value)) {
                binding.arg === 'disable'? el.disabled = true : hideElement(el);
            }
        }
    },
    {
        name: 'downloadable',
        func: (el, binding) => {
            if (binding.value == null){
                el.innerText = 'لا يوجد'
                el.style.cursor = 'not-allowed';
            }
        }
    },
    {
        name: 'siteRoute',
        func: (el, binding) => {
            if (typeof binding.value == 'object' || typeof binding.value == 'string' || typeof binding.value.name == 'object'){
                el.setAttribute('href', appConfig.site.appUrl + '/' +
                            appConfig.site.endPoint[
                                typeof binding.value == 'string'? binding.value : binding.value.name
                            ] + 
                            ( typeof binding.value.param == 'object' ? '?' + new URLSearchParams(binding.value.param).toString() : '')
                )
            }
        }
    }
]


// =============
// Private helper
// =============
function hideElement(el) {
    // el.style.display = 'none';
    el.remove();
}
